export default __webpack_public_path__ + "static/pack-b9628251cceaa7266366ccfd8ffea035.jpg";